import $ from 'jquery'
import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'
import URI from 'urijs'
import env from '@/config/env'
import tablesDiscountsLocal from '@/config/tradeTermsConfig.json'
import api from '@/api/api'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import TextareaField from '@/components/general/fields/textarea/textarea'
import SelectField from '@/components/general/fields/select/select'
import SearchField from '@/components/general/fields/search/search'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import InputCheck from '@/components/general/fields/inputcheck/checkbox'
import FileField from '@/components/general/fields/file/file'
import DateField from '@/components/general/fields/date/date'
import SortField from '@/components/general/fields/sort/sort'

const Parse = require('parse')
let subscriptionProgress

export default {
  name: 'contracts-list',
  data () {
    return {
      contracts: [],
      tablesDiscounts: {},
      menuOptions: [
        {
          iconClass: 'fa fa-pencil',
          name: this.$t('private.contracts.list.menu_more_options.edit_contract'),
          action: 'edit'
        },
        {
          iconClass: 'fa fa-archive',
          name: this.$t('private.contracts.list.menu_more_options.archive_contract'),
          action: 'archive'
        }
      ],
      filters: {
        ascending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.contracts.list.filters.sort_options.created_at'),
          value: 'appCreationDate',
          name: this.$t('private.contracts.list.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.contracts.list.filters.limit_options.50'),
          value: 50,
          name: this.$t('private.contracts.list.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.contracts.list.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.contracts.list.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.contracts.list.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        state: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.state'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.state_options.green'),
            value: 0
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.red'),
            value: 1
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.yellow'),
            value: 2
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.black'),
            value: 3
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.purple'),
            value: 4
          }],
          style: {
            width: '100px',
            marginTop: '0px'
          }
        },
        exported: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.all'),
            value: ''
          }, {
            fakeValue: this.$t('private.contracts.list.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.contracts.list.filters.exported_options.no'),
            value: false
          }],
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        contractMode: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.contractMode'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.contractMode_1'),
            value: -1
          }, {
            fakeValue: this.$t('private.contracts.list.filters.contractMode_2'),
            value: 2
          }],
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        hidden: { // ESTO SE HACE POR QUE AL PARECER HAY UN BUG EN LOS FILTROS DENTRO DE LA TABLA Y ESTO LO SOLUCIONA
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.contracts.list.filters.exported_options.no'),
            value: false
          }],
          style: {
            display: 'none'
          }
        },
        since: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.since'),
          error: false,
          active: false,
          style: {
            width: '110px',
            marginTop: '3px'
          }
        },
        until: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.until'),
          error: false,
          active: false,
          style: {
            width: '110px'
          }
        },
        seller: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.client_code'),
          type: 'text',
          error: false,
          filters: {
            maxLength: 8
          },
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      getContractsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      getSearchClients: false,
      formCreate: {
        fields: {
          client: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.client'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          state: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.state'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.state_options.green'),
              value: 0
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.red'),
              value: 1
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.yellow'),
              value: 2
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.black'),
              value: 3
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.purple'),
              value: 4
            }],
            filters: {
              type: 'number',
              required: true
            }
          },
          appCreationDate: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.app_creation_cate'),
            error: false,
            filters: {
              type: 'date'
            }
          },
          associateAccounts: {
            id: _.uniqueId('field_'),
            display: false,
            name: this.$t('private.contracts.list.fields.associate_accounts'),
            disabled: true,
            error: false,
            value: {},
            options: {},
            filters: {
              type: 'manyOptions'
            }
          },
          brands: {
            id: _.uniqueId('field_'),
            display: true,
            inline: true,
            error: false,
            value: {
              // premium: false,
              // prestige: false,
              dso: false,
              iso: false,
              opi: false
            },
            options: {
              // premium: {
              //   name: this.$t('private.contracts.list.fields.premium'),
              //   disabled: false,
              //   value: false
              // },
              // prestige: {
              //   name: this.$t('private.contracts.list.fields.prestige'),
              //   disabled: false,
              //   value: false
              // },
              dso: {
                name: this.$t('private.contracts.list.fields.dso'),
                disabled: false,
                value: false
              },
              iso: {
                name: this.$t('private.contracts.list.fields.iso'),
                disabled: false,
                value: false
              },
              opi: {
                name: this.$t('private.contracts.list.fields.opi'),
                disabled: false,
                value: false
              }

            },
            filters: {
              type: 'manyOptions',
              enum: [
                // 'premium',
                // 'prestige',
                'dso',
                'iso',
                'opi'
              ],
              required: true
            }
          },
          // premiumDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_date'),
          //   error: false,
          //   filters: {
          //     type: 'date'
          //   }
          // },
          // premiumSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_salon'),
          //   error: false,
          //   active: false,
          //   options: [{
          //     fakeValue: this.$t('private.contracts.list.fields.premium_salon'),
          //     value: ''
          //   }],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // premiumSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: -1,
          //   name: this.$t('private.contracts.list.fields.premium_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.premium_Brands'),
          //   error: false,
          //   value: {
          //     breandWELLA: false,
          //     breandIOXIN: false,
          //     breandSP: false
          //   },
          //   options: {
          //     breandWELLA: {
          //       name: this.$t('private.contracts.list.fields.BRAND_WELLA'),
          //       value: 1
          //     },
          //     breandIOXIN: {
          //       name: this.$t('private.contracts.list.fields.BRAND_NIOXIN'),
          //       value: 3
          //     },
          //     breandSP: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP'),
          //       value: 2
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions',
          //     enum: ['breandWELLA', 'breandIOXIN', 'breandSP'],
          //     required: true
          //   }
          // },
          // premiumMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_MTKG'),
          //   error: false,
          //   active: false,
          //   options: [],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // premiumMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   disabled: false,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_MTKG_Subtype'),
          //   error: false,
          //   type: 'text',
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumMTKGSubtypeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: false,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype_Brands'),
          //   error: false,
          //   value: {
          //     breandWELLA: false,
          //     breandIOXIN: false,
          //     breandSP: false
          //   },
          //   options: {},
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          // premiumATS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_ATS_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPTS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_PTS_1'),
          //   type: 'text',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_section_1'),
          //   type: 'text',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number',
          //     required: false
          //   }
          // },
          // premiumVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_education_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_potential'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_rappel_frequency'),
          //   type: 'string',
          //   error: false,
          //   options: [],
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_date'),
          //   error: false,
          //   active: false,
          //   filters: {
          //     type: 'date'
          //   }
          // },
          // prestigeSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_salon'),
          //   error: false,
          //   active: false,
          //   options: [{
          //     fakeValue: this.$t('private.contracts.list.fields.premium_salon'),
          //     value: ''
          //   }],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // prestigeSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: -1,
          //   name: this.$t('private.contracts.list.fields.prestige_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeATS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_ATS'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePTS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_PTS'),
          //   type: 'text',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.prestige_Brands'),
          //   error: false,
          //   value: {
          //     // brandSEBASTIAN: false,
          //     brandSP_DIAMOND: false,
          //     brandSASSOON: false
          //   },
          //   options: {
          //     // brandSEBASTIAN: {
          //     //   name: this.$t('private.contracts.list.fields.BRAND_SEBASTIAN'),
          //     //   value: 6
          //     // },
          //     brandSP_DIAMOND: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
          //       value: 4,
          // 	  disabled: true
          //     },
          //     brandSASSOON: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
          //       value: 5,
          // 	  disabled: true
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions',
          //     enum: [
          //        // 'brandSEBASTIAN',
          //        'brandSP_DIAMOND',
          //        'brandSASSOON'
          //     ],
          //     required: true
          //   }
          // },
          // prestigeMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG'),
          //   error: false,
          //   active: false,
          // disabled: true,
          //   options: [{
          //     fakeValue: this.$t('private.contracts.list.fields.prestige_MTKG'),
          //     value: ''
          //   }],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // prestigeMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype'),
          //   type: 'text',
          //   error: false,
          //  disabled: true,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeMTKGSubtypeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: false,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype_Brands'),
          //   error: false,
          //   value: {
          //     brandSEBASTIAN: false,
          //     brandSP_DIAMOND: false,
          //     brandSASSOON: false
          //   },
          //   options: {},
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          // prestigeSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_section_1'),
          //   type: 'text',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeEducation: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_education'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_potential'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_frequency'),
          //   type: 'text',
          //   error: false,
          // disabled: true,
          //   options: [],
          //   filters: {
          //     type: 'string'
          //   }
          // },
          dsoDate: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.dso_date'),
            error: false,
            active: false,
            filters: {
              type: 'date'
            }
          },
          dsoSalon: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.dso_salon'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.dso_salon'),
              value: ''
            }],
            filters: {
              type: 'string',
              required: false
            }
          },
          dsoSalonValue: {
            id: _.uniqueId('field_'),
            display: true,
            value: -1,
            name: this.$t('private.contracts.list.fields.dso_salon_value'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoPTS: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_PTS'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'string'
            }
          },
          dsoBrands: {
            id: _.uniqueId('field_'),
            display: true,
            name: this.$t('private.contracts.list.fields.add_Brands'),
            error: false,
            value: {
              brandSP_DIAMOND: false,
              brandSASSOON: false
            },
            options: {
              brandSP_DIAMOND: {
                name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
                value: 4,
                disabled: true
              },
              brandSASSOON: {
                name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
                value: 5,
                disabled: true
              }
            },
            filters: {
              type: 'manyOptions',
              enum: [
                'brandSP_DIAMOND',
                'brandSASSOON'
              ],
              required: true
            }
          },
          dsoMTKG: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.dso_MTKG'),
            error: false,
            active: false,
            disabled: true,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.dso_MTKG_options.wella_app'),
              value: this.$t('private.contracts.list.fields.dso_MTKG_options.wella_app')
            }, {
              fakeValue: this.$t('private.contracts.list.fields.dso_MTKG_options.congreso'),
              value: this.$t('private.contracts.list.fields.dso_MTKG_options.congreso')
            }, {
              fakeValue: this.$t('private.contracts.list.fields.dso_MTKG_options.evento_sebastian'),
              value: this.$t('private.contracts.list.fields.dso_MTKG_options.evento_sebastian')
            }],
            filters: {
              type: 'string',
              required: false
            }
          },
          dsoMTKGSubtype: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_MTKG_Subtype'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'string'
            }
          },
          dsoSection: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_section'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'string'
            }
          },
          dsoRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          briogeoRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.briogeo_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoDiscount: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_discount'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoRappelMarketing: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_rappel_marketing'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoEducation: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_education'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoPotential: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_potential'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoRappelFrequency: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_rappel_frequency'),
            type: 'text',
            error: false,
            disabled: true,
            options: [{
              fakeValue: this.$t('utils.frequency.quarterly'),
              value: this.$t('utils.frequency.quarterly')
            }, {
              fakeValue: this.$t('utils.frequency.biannual'),
              value: this.$t('utils.frequency.biannual')
            }, {
              fakeValue: this.$t('utils.frequency.annual'),
              value: this.$t('utils.frequency.annual')
            }],
            filters: {
              type: 'string'
            }
          },
          hasPrestigeCondition: {
            id: _.uniqueId('field_'),
            display: true,
            name: '',
            inline: true,
            error: false,
            disabled: false,
            value: {
              FY2223: false
            },
            options: {
              FY2223: {
                name: this.$t('private.contracts.list.fields.has_prestige_condition_FY2223'),
                disabled: false
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['FY2223']
            }
          },
          wellaQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_quantity'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          wellaDiscount: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_discount'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          wellaVolumeRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_volume_rappel'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          // sebManRappel: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_rappel'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // sebManDiscount: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_discount'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          rappelMKTG: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          rappelMKTGManual: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg_manual'),
            type: 'text',
            error: false,
            disabled: false,
            filters: {
              type: 'string'
            }
          },
          opiQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_quantity'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          opiDiscount: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_discount'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          opiRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_rappel'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          observations: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.observations'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          prorated: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.prorated'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.prorated_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.contracts.list.fields.prorated_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          proratedMonth: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.prorated_month'),
            type: 'number',
            error: false,
            disabled: true,
            options: [{
              fakeValue: 1,
              value: 1
            }, {
              fakeValue: 2,
              value: 2
            }, {
              fakeValue: 3,
              value: 3
            }, {
              fakeValue: 4,
              value: 4
            }, {
              fakeValue: 5,
              value: 5
            }, {
              fakeValue: 6,
              value: 6
            }, {
              fakeValue: 7,
              value: 7
            }, {
              fakeValue: 8,
              value: 8
            }, {
              fakeValue: 9,
              value: 9
            }, {
              fakeValue: 10,
              value: 10
            }, {
              fakeValue: 11,
              value: 11
            }, {
              fakeValue: 12,
              value: 12
            }],
            filters: {
              type: 'number',
              required: false
            }
          },
          mktNews: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          pdf: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.contracts.list.fields.pdf'),
            pdf: true,
            readAsDataURL: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 30,
              formatsAllowed: ['pdf'],
              required: true
            }
          }
        },
        active: false
      },
      displayCreateContract: false,
      formUpdate: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          client: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.client'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          clientCode: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            type: 'text',
            name: this.$t('private.contracts.list.fields.client'),
            error: false,
            active: false,
            disabled: true,
            options: [],
            filters: {
              type: 'string'
            }
          },
          state: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.state'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.state_options.green'),
              value: 0
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.red'),
              value: 1
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.yellow'),
              value: 2
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.black'),
              value: 3
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.purple'),
              value: 4
            }],
            filters: {
              type: 'number',
              required: true
            }
          },
          associateAccounts: {
            id: _.uniqueId('field_'),
            display: false,
            name: this.$t('private.contracts.list.fields.associate_accounts'),
            disabled: true,
            error: false,
            value: {},
            options: {},
            filters: {
              type: 'manyOptions'
            }
          },
          // prestigeDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_date'),
          //   disabled: true,
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeATS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_ATS'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePTS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_PTS'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_salon'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeEvent: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   error: false,
          //   name: this.$t('private.contracts.list.fields.prestige_event'),
          //   value: false,
          //   disabled: true,
          //   filters: {
          //     type: 'boolean',
          //     required: false
          //   }
          // },
          // prestigeSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_section_1'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeSection2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_section_2'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeSection3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_section_3'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeEducation: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_education'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_potential'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_frequency'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.prestige_Brands_view'),
          //   error: false,
          //   value: {
          //     // 6: false,
          //     4: false,
          //     5: false
          //   },
          //   options: {
          //     // 6: {
          //     //   name: this.$t('private.contracts.list.fields.BRAND_SEBASTIAN'),
          //     //   disabled: true
          //     // },
          //     4: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
          //       disabled: true
          //     },
          //     5: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
          //       disabled: true
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          // premiumDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   type: 'text',
          //   name: this.$t('private.contracts.list.fields.premium_date'),
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_MTKG'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_MTKG_Subtype'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_salon'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumATS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_ATS_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumATS2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_ATS_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumATS3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_ATS_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPTS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: false,
          //   name: this.$t('private.contracts.list.fields.premium_PTS_1'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumPTS2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: false,
          //   name: this.$t('private.contracts.list.fields.premium_PTS_2'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumPTS3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: false,
          //   name: this.$t('private.contracts.list.fields.premium_PTS_3'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumEvent: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   error: false,
          //   name: this.$t('private.contracts.list.fields.premium_event'),
          //   value: false,
          //   disabled: true,
          //   filters: {
          //     type: 'boolean',
          //     required: false
          //   }
          // },
          // premiumSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_section_1'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSection2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_section_2'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSection3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_section_3'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappel2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappel3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumVariableDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumVariableDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_education_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_education_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_education_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_potential'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_frequency'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.premium_Brands_view'),
          //   error: false,
          //   value: {
          //     1: false,
          //     3: false,
          //     2: false
          //   },
          //   options: {
          //     1: {
          //       name: this.$t('private.contracts.list.fields.BRAND_WELLA'),
          //       disabled: true
          //     },
          //     3: {
          //       name: this.$t('private.contracts.list.fields.BRAND_NIOXIN'),
          //       disabled: true
          //     },
          //     2: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP'),
          //       disabled: true
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          dsoDate: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_date'),
            disabled: true,
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoPTS: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_PTS'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoMTKG: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_MTKG'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoMTKGSubtype: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_MTKG_Subtype'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoSalon: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_salon'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoSalonValue: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_salon_value'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoSection: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_section'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_rappel'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          briogeoRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.briogeo_rappel'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoDiscount: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_discount'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoRappelMarketing: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_rappel_marketing'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoEducation: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_education'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoPotential: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_potential'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoRappelFrequency: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_rappel_frequency'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoBrands: {
            id: _.uniqueId('field_'),
            display: true,
            name: this.$t('private.contracts.list.fields.view_brands'),
            error: false,
            value: {
              4: false,
              5: false
            },
            options: {
              4: {
                name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
                disabled: true
              },
              5: {
                name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
                disabled: true
              }
            },
            filters: {
              type: 'manyOptions'
            }
          },
          hasPrestigeCondition: {
            id: _.uniqueId('field_'),
            display: true,
            name: '',
            inline: true,
            error: false,
            value: {
              FY2223: false
            },
            options: {
              FY2223: {
                name: this.$t('private.contracts.list.fields.has_prestige_condition_FY2223'),
                disabled: true
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['FY2223']
            }
          },
          wellaQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_quantity'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          wellaDiscount: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_discount'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          wellaVolumeRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_volume_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          // sebManRappel: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_rappel'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // sebManDiscount: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_discount'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          rappelMKTG: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          rappelMKTGManual: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg_manual'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          observations: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.observations'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          mktNews: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          pdf: {
            id: _.uniqueId('field_'),
            display: true,
            disabled: true,
            value: {},
            name: this.$t('private.contracts.list.fields.pdf'),
            pdf: true,
            readAsDataURL: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 30,
              formatsAllowed: ['pdf']
              // required       : true
            }
          },
          opiQuantity: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_quantity'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          opiDiscount: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_discount'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          opiRappel: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          prorated: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.prorated'),
            error: false,
            type: 'text',
            disabled: true,
            filters: {
              type: 'string',
              required: false
            }
          },
          proratedMonth: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.prorated_month'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          }
        },
        active: false
      },
      displayUpdateContract: false,
      getClientsActive: false,
      getDelegationsActive: false,
      exportContractsActive: false,
      migrateContractsWindow: {
        display: false,
        migrateCSVFileActive: false,
        contractsToCreated: [],
        contractsToUpdate: [],
        contractsWithErrors: [],
        fields: {
          separator: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      displayFoo: false,
      totalContracts: 0,
      exportZipPDFsWindow: {
        sessionId: null,
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.list.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.list.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0,
          download: 0
        }
      }
    }
  },
  methods: {
    getParseConfig () {
      let vm = this

      function parseTablesDiscounts (tablesDiscounts) {
        vm.tablesDiscounts = tablesDiscounts
        // vm.tablesDiscounts.dso.premium.forEach((premium) => {
        //   vm.formCreate.fields.premiumSalon.options.push({
        // 	  fakeValue: premium.tipo,
        // 	  value: premium.tipo
        //   })
        // })
        // vm.tablesDiscounts.dso.prestige.forEach((prestige) => {
        //   vm.formCreate.fields.prestigeSalon.options.push({
        // 	  fakeValue: prestige.tipo,
        // 	  value: prestige.tipo
        //   })
        // })
        vm.tablesDiscounts.DSO.tipoClientes.forEach((typeClient) => {
          vm.formCreate.fields.dsoSalon.options.push({
            fakeValue: typeClient.tipo,
            value: typeClient.tipo
          })
        })
      }

      function getTablesDiscounts (tablesDiscountsFile) {
        const uriOrigin = new URI(tablesDiscountsFile._url)
        const pathname = uriOrigin.pathname()
        const url = `${env.api.baseUrl}${pathname}`
        fetch(url)
          .then(response => response.json())
          .then(parseTablesDiscounts).catch(err => {
          console.error(err)
          parseTablesDiscounts(tablesDiscountsLocal)
        })
      }

      Parse.Config.get().then(function (config) {
        const tablesDiscountsFile = config.get('tablesDiscounts')
        if (tablesDiscountsFile) {
          getTablesDiscounts(tablesDiscountsFile)
        } else {
          parseTablesDiscounts(tablesDiscountsLocal)
        }
      }, function (error) {
        console.log('getParseConfig > Error')
        console.error(error)
      })
    },
    parseBrands (brands) {
      const _bransd = {
        1: 'Wella',
        2: 'SP',
        3: 'Nioxin',
        4: 'SSP',
        5: 'Sassoon',
        6: 'Sebastian'
      }

      let parseBransObjs = []

      if (brands && brands.length > 0) {
        _.each(brands, (value) => {
          parseBransObjs.push(_bransd[value])
        })

        return parseBransObjs.map(k => k).join(', ')
      } else {
        return ''
      }
    },
    filterSubmit: _.debounce(function () {
      let vm = this

      vm.getContracts()
    }, 1000),
    rowClicked (element, value) {
      element.rowSelected = value

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true
    },
    actionSort (event, col) {
      let vm = this

      vm.filters.ascending.value = ''
      vm.filters.descending.value = ''

      if (event.sort_default) vm.filters.descending.value = 'appCreationDate'

      if (event.sort_asc) vm.filters.ascending.value = col

      if (event.sort_desc) vm.filters.descending.value = col

      vm.getContracts()
    },
    actionSelectedBrands (event) {
      let vm = this

      let brands = vm.formCreate.fields.brands

      // vm.formCreate.fields.premiumSalon.filters.required = brands.value['premium']
      // vm.formCreate.fields.prestigeSalon.filters.required = brands.value['prestige']
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = false
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = false
      vm.formCreate.fields.dsoSalon.filters.required = brands.value['dso']

      if (brands.value['dso']) {
        // brands.options['premium'].value = brands.value['premium']
        // brands.options['prestige'].value = brands.value['prestige']
        brands.options['dso'].value = brands.value['dso']
        brands.options['iso'].disabled = true
        brands.options['opi'].disabled = true
      } else if (brands.value['iso']) {
        brands.options['iso'].value = brands.value['iso']
        // brands.options['premium'].disabled = true
        // brands.options['prestige'].disabled = true
        brands.options['dso'].disabled = true
        brands.options['opi'].disabled = true
      } else if (brands.value['opi']) {
        brands.options['opi'].value = brands.value['opi']
        // brands.options['premium'].disabled = true
        // brands.options['prestige'].disabled = true
        brands.options['dso'].disabled = true
        brands.options['iso'].disabled = true
      } else {
        // brands.options['premium'].value = false
        // brands.options['prestige'].value = false
        brands.options['dso'].value = false
        brands.options['iso'].value = false
        brands.options['opi'].value = false
        // brands.options['premium'].disabled = false
        // brands.options['prestige'].disabled = false
        brands.options['dso'].disabled = false
        brands.options['iso'].disabled = false
        brands.options['opi'].disabled = false
      }
    },
    // actionSelectPremiumSalon (event) {
    //   let vm = this
    //
    //   let client = _.find(vm.formCreate.fields.client.options, (client) => {
    //     return client.value.objectId === vm.formCreate.fields.client.value
    //   })
    //
    //   if (!client && vm.formCreate.fields.premiumSalon.value !== '') {
    //     let message = {
    //       message: [vm.$t('errors.custom.012')],
    //       type: 'error'
    //     }
    //
    //     vm.$root.$emit('showMessage', message)
    //
    //     vm.formCreate.fields.premiumSalon.value = ''
    //     vm.formCreate.fields.premiumSalon.fakeValue = ''
    //     vm.formCreate.fields.premiumMTKG.value = ''
    //     vm.formCreate.fields.premiumMTKG.fakeValue = ''
    //     vm.formCreate.fields.premiumMTKGSubtype.value = ''
    //
    //     // this.$refs['premiumSalon'].field.value = vm.formCreate.fields.premiumSalon.value
    //     // this.$refs['premiumSalon'].field.fakeValue = vm.formCreate.fields.premiumSalon.fakeValue
    //     // this.$refs['premiumMTKG'].field.value = vm.formCreate.fields.premiumMTKG.value
    //     // this.$refs['premiumMTKG'].field.fakeValue = vm.formCreate.fields.premiumMTKG.fakeValue
    //     // this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    //
    //     return
    //   }
    //
    //   // vm.formCreate.fields.premiumSalonValue.value = -1
    //   // vm.formCreate.fields.premiumSection1.value = ''
    //   // vm.formCreate.fields.premiumDiscount1.value = ''
    //   // vm.formCreate.fields.premiumVariableDiscount1.value = ''
    //   // vm.formCreate.fields.premiumRappel1.value = ''
    //   // vm.formCreate.fields.premiumRappelMarketing1.value = ''
    //   // vm.formCreate.fields.premiumATS1.value = ''
    //   // vm.formCreate.fields.premiumPTS1.value = ''
    //   // vm.formCreate.fields.premiumEducation1.value = ''
    //   // vm.formCreate.fields.premiumPotential.value = ''
    //   // vm.formCreate.fields.premiumMTKG.filters.required = false
    //   // vm.formCreate.fields.premiumMTKGSubtype.value = ''
    //
    //   const premium = vm.tablesDiscounts.dso.premium.find((item) => item.tipo === vm.formCreate.fields.premiumSalon.value)
    //
    //   if (premium) {
    //     const index = 0
    //     const premiumPotential = 4000
    //     vm.formCreate.fields.premiumSalonValue.value = index
    //     vm.formCreate.fields.premiumSection1.value = `${premium.tramos[index].tramo} €`
    //     vm.formCreate.fields.premiumDiscount1.value = premium.tramos[index].descuento
    //     vm.formCreate.fields.premiumVariableDiscount1.value = premium.tramos[index].descuentoVariable
    //     vm.formCreate.fields.premiumRappel1.value = premium.tramos[index].rappel
    //     vm.formCreate.fields.premiumRappelMarketing1.value = premium.tramos[index].rappelMarketing
    //     vm.formCreate.fields.premiumATS1.value = premium.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.premiumEducation1.value = premium.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.premiumPotential.value = premiumPotential * client.value.employeesQuantity
    //     vm.formCreate.fields.premiumMTKG.filters.required = true
    //     const premiumMTKGOpts = []
    //     const premiumRappelFrequencyOpts = []
    //     premium.rappel.forEach((rappel) => {
    //       premiumRappelFrequencyOpts.push({
    //         fakeValue: rappel,
    //         value: rappel
    //       })
    //     })
    //     premium.marketing.forEach((marketing) => {
    //       premiumMTKGOpts.push(Object.assign(marketing, {
    //         fakeValue: marketing.nombre,
    //         value: marketing.nombre
    //       }))
    //     })
    //     vm.formCreate.fields.premiumRappelFrequency.options = premiumRappelFrequencyOpts
    //     vm.formCreate.fields.premiumMTKG.options = premiumMTKGOpts
    //   }
    //
    //   this.$refs['premiumSection1'].field.value = vm.formCreate.fields.premiumSection1.value
    //   this.$refs['premiumDiscount1'].field.value = vm.formCreate.fields.premiumDiscount1.value
    //   this.$refs['premiumVariableDiscount1'].field.value = vm.formCreate.fields.premiumVariableDiscount1.value
    //   this.$refs['premiumRappel1'].field.value = vm.formCreate.fields.premiumRappel1.value
    //   this.$refs['premiumRappelMarketing1'].field.value = vm.formCreate.fields.premiumRappelMarketing1.value
    //   this.$refs['premiumATS1'].field.value = vm.formCreate.fields.premiumATS1.value
    //   this.$refs['premiumPTS1'].field.value = vm.formCreate.fields.premiumPTS1.value
    //   this.$refs['premiumEducation1'].field.value = vm.formCreate.fields.premiumEducation1.value
    //   this.$refs['premiumPotential'].field.value = vm.formCreate.fields.premiumPotential.value
    //   this.$refs['premiumPotential'].field.value = vm.formCreate.fields.premiumPotential.value
    //   this.$refs['premiumMTKG'].field.value = vm.formCreate.fields.premiumMTKG.value
    //   this.$refs['premiumMTKG'].field.fakeValue = vm.formCreate.fields.premiumMTKG.fakeValue
    //   this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    // },
    // actionSelectPremiumMTKG (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.premiumSalon.value === '') {
    //     vm.formCreate.fields.premiumMTKGSubtype.value = ''
    //     this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    //     return
    //   }
    //
    //   let premiumMTKGSubtype = ''
    //   const marketing = vm.formCreate.fields.premiumMTKG.options.find((item) => item.value === event)
    //
    //   if (marketing) {
    //     if (marketing.congreso) {
    //       premiumMTKGSubtype = `Congreso: ${marketing.congreso}€`
    //     } else {
    //       premiumMTKGSubtype = `Pts app ${marketing.ptsApp ? marketing.ptsApp : ''}`
    //     }
    //   }
    //
    //   vm.formCreate.fields.premiumPTS1.value = marketing && marketing.ptsApp ? marketing.ptsApp : ''
    //   vm.formCreate.fields.premiumEducation1.value = marketing && ('congreso' in marketing) ? marketing.congreso : vm.formCreate.fields.premiumEducation1.value
    //   vm.formCreate.fields.premiumMTKGSubtype.value = premiumMTKGSubtype
    //
    //   this.$refs['premiumATS1'].field.value = vm.formCreate.fields.premiumATS1.value
    //   this.$refs['premiumPTS1'].field.value = vm.formCreate.fields.premiumPTS1.value
    //   this.$refs['premiumEducation1'].field.value = vm.formCreate.fields.premiumEducation1.value
    //   this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    // },
    // validateSelectPremiumMTKGSubtypeBrands () {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.premiumSalon.value === '') return
    //
    //   let brands = vm.formCreate.fields.premiumMTKGSubtypeBrands
    //   let selected = []
    //   let notSelected = []
    //
    //   _.each(brands.value, (value, key) => {
    //     if (value) selected.push(key)
    //     else notSelected.push(key)
    //   })
    //
    //   try {
    //     if (selected.length > 0 && selected.length === 2) {
    //       _.each(notSelected, (key) => {
    //         if (brands.options[key]) brands.options[key].disabled = true
    //       })
    //     } else {
    //       _.each(brands.options, (x) => {
    //         x.disabled = false
    //       })
    //     }
    //   } catch (error) {
    //     console.log('Error', error)
    //   }
    // },
    // actionSelectPremiumBrands (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.premiumSalon.value === '') return
    //
    //   if (vm.formCreate.fields.premiumMTKG.value === this.$t('private.contracts.list.fields.MTKG_options.materiales_MKT')) {
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.value = {}
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.display = false
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.options = {}
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = false
    //
    //     let premiumBrands = {}
    //
    //     _.each(vm.formCreate.fields.premiumBrands.value, (value, key) => {
    //       if (value) {
    //         premiumBrands[key] = {
    //           name: vm.formCreate.fields.premiumBrands.options[key].name,
    //           value: vm.formCreate.fields.premiumBrands.options[key].value,
    //           disabled: false
    //         }
    //       }
    //     })
    //
    //     if (_.size(premiumBrands) > 0) {
    //       vm.formCreate.fields.premiumMTKGSubtypeBrands.options = premiumBrands
    //       vm.formCreate.fields.premiumMTKGSubtypeBrands.display = true
    //       vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = true
    //     } else {
    //       let message = {
    //         message: [vm.$t('errors.custom.010').replace('{brand}', 'Premium')],
    //         type: 'error'
    //       }
    //
    //       vm.$root.$emit('showMessage', message)
    //     }
    //   }
    // },
    // actionSelectPrestigeSalon (event) {
    //   let vm = this
    //
    //   let client = _.find(vm.formCreate.fields.client.options, (client) => {
    //     return client.value.objectId === vm.formCreate.fields.client.value
    //   })
    //
    //   if (!client && vm.formCreate.fields.prestigeSalon.value !== '') {
    //     let message = {
    //       message: [vm.$t('errors.custom.012')],
    //       type: 'error'
    //     }
    //
    //     vm.$root.$emit('showMessage', message)
    //
    //     vm.formCreate.fields.prestigeSalon.value = ''
    //     vm.formCreate.fields.prestigeSalon.fakeValue = ''
    //     this.$refs['prestigeSalon'].field.value = vm.formCreate.fields.prestigeSalon.value
    //     this.$refs['prestigeSalon'].field.fakeValue = vm.formCreate.fields.prestigeSalon.fakeValue
    //     vm.resetFieldPrestige()
    //     vm.enabledFieldPrestige(false)
    //     return
    //   }
    //
    //   vm.resetFieldPrestige()
    //   vm.enabledFieldPrestige(event !== '')
    //   vm.formCreate.fields.prestigeSalonValue.value = -1
    //   vm.formCreate.fields.prestigeMTKG.filters.required = false
    //   const prestige = vm.tablesDiscounts.dso.prestige.find((item) => item.tipo === vm.formCreate.fields.prestigeSalon.value)
    //   if (prestige) {
    //     const index = 0
    //     const prestigePotential = 7000
    //     vm.formCreate.fields.prestigeSalonValue.value = index
    //     vm.formCreate.fields.prestigeSection1.value = `${prestige.tramos[index].tramo} €`
    //     vm.formCreate.fields.prestigeDiscount1.value = prestige.tramos[index].descuento
    //     // vm.formCreate.fields.prestigeVariableDiscount1.value = prestige.tramos[index].descuentoVariable
    //     vm.formCreate.fields.prestigeRappel1.value = prestige.tramos[index].rappel
    //     vm.formCreate.fields.prestigeRappelMarketing1.value = prestige.tramos[index].rappelMarketing
    //     // vm.formCreate.fields.prestigeATS.value = prestige.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.prestigeEducation.value = prestige.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.prestigePotential.value = prestigePotential * client.value.employeesQuantity
    //     vm.formCreate.fields.prestigeMTKG.filters.required = true
    //     const prestigeMTKGOpts = []
    //     const prestigeRappelFrequencyOpts = []
    //     prestige.rappel.forEach((rappel) => {
    //       prestigeRappelFrequencyOpts.push({
    //         fakeValue: rappel,
    //         value: rappel
    //       })
    //     })
    //     prestige.marketing.forEach((marketing) => {
    //       prestigeMTKGOpts.push(Object.assign(marketing, {
    //         fakeValue: marketing.nombre,
    //         value: marketing.nombre
    //       }))
    //     })
    //     vm.formCreate.fields.prestigeRappelFrequency.options = prestigeRappelFrequencyOpts
    //     vm.formCreate.fields.prestigeMTKG.options = prestigeMTKGOpts
    //   }
    //
    //   this.$refs['prestigeSection1'].field.value = vm.formCreate.fields.prestigeSection1.value
    //   this.$refs['prestigeDiscount1'].field.value = vm.formCreate.fields.prestigeDiscount1.value
    //   // this.$refs['prestigeVariableDiscount1'].field.value = vm.formCreate.fields.prestigeVariableDiscount1.value
    //   this.$refs['prestigeRappel1'].field.value = vm.formCreate.fields.prestigeRappel1.value
    //   this.$refs['prestigeRappelMarketing1'].field.value = vm.formCreate.fields.prestigeRappelMarketing1.value
    //   // this.$refs['prestigeATS'].field.value = vm.formCreate.fields.prestigeATS.value
    //   this.$refs['prestigePTS'].field.value = vm.formCreate.fields.prestigePTS.value
    //   this.$refs['prestigeEducation'].field.value = vm.formCreate.fields.prestigeEducation.value
    //   this.$refs['prestigePotential'].field.value = vm.formCreate.fields.prestigePotential.value
    //   this.$refs['prestigeMTKG'].field.value = vm.formCreate.fields.prestigeMTKG.value
    //   this.$refs['prestigeMTKG'].field.fakeValue = vm.formCreate.fields.prestigeMTKG.fakeValue
    //   this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    // },
    // enabledFieldPrestige (enabled) {
    //   let vm = this
    //
    //   vm.formCreate.fields.prestigeSalonValue.disabled = !enabled
    //     // vm.formCreate.fields.prestigeATS.disabled = !enabled
    //   vm.formCreate.fields.prestigeBrands.options.brandSP_DIAMOND.disabled = !enabled
    //   vm.formCreate.fields.prestigeBrands.options.brandSASSOON.disabled = !enabled
    //   vm.formCreate.fields.prestigeMTKG.disabled = !enabled
    //   vm.formCreate.fields.prestigeMTKGSubtype.disabled = !enabled
    //   vm.formCreate.fields.prestigePTS.disabled = !enabled
    //   vm.formCreate.fields.prestigeSection1.disabled = !enabled
    //   vm.formCreate.fields.prestigeRappel1.disabled = !enabled
    //   vm.formCreate.fields.prestigeDiscount1.disabled = !enabled
    //   // vm.formCreate.fields.prestigeVariableDiscount1.disabled = !enabled
    //  vm.formCreate.fields.prestigeRappelMarketing1.disabled = !enabled
    //   vm.formCreate.fields.prestigeEducation.disabled = !enabled
    //   vm.formCreate.fields.prestigePotential.disabled = !enabled
    //   vm.formCreate.fields.prestigeRappelFrequency.disabled = !enabled
    // },
    // resetFieldPrestige () {
    //   let vm = this
    //
    //     // vm.formCreate.fields.prestigeATS.value = ''
    //  vm.formCreate.fields.prestigeBrands.value = {
    // 	 // brandSEBASTIAN: false,
    // 	 brandSP_DIAMOND: false,
    // 	 brandSASSOON: false
    //  }
    //   vm.formCreate.fields.prestigeMTKG.value = ''
    //  vm.formCreate.fields.prestigeMTKG.fakeValue = ''
    //   vm.formCreate.fields.prestigeMTKGSubtype.value = ''
    //   vm.formCreate.fields.prestigePTS.value = ''
    //   vm.formCreate.fields.prestigeSection1.value = ''
    //   vm.formCreate.fields.prestigeRappel1.value = ''
    //   vm.formCreate.fields.prestigeDiscount1.value = ''
    //   // vm.formCreate.fields.prestigeVariableDiscount1.value = ''
    // vm.formCreate.fields.prestigeRappelMarketing1.value = ''
    //   vm.formCreate.fields.prestigeEducation.value = ''
    //   vm.formCreate.fields.prestigePotential.value = ''
    //   vm.formCreate.fields.prestigeRappelFrequency.value = ''
    //   vm.formCreate.fields.prestigeRappelFrequency.fakeValue = ''
    //   vm.formCreate.fields.hasPrestigeCondition.value = {
    //     FY2223: false
    //   }
    //
    //   this.$refs['prestigeMTKG'].field.value = vm.formCreate.fields.prestigeMTKG.value
    //   this.$refs['prestigeMTKG'].field.fakeValue = vm.formCreate.fields.prestigeMTKG.fakeValue
    //   this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    //   this.$refs['prestigeRappelFrequency'].field.value = vm.formCreate.fields.prestigeRappelFrequency.value
    //   this.$refs['prestigeRappelFrequency'].field.fakeValue = vm.formCreate.fields.prestigeRappelFrequency.fakeValue
    // },
    // actionSelectPrestigeMTKG (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.prestigeSalon.value === '') {
    //     vm.formCreate.fields.prestigeEvent.value = false
    //     vm.formCreate.fields.prestigeMTKGSubtype.value = ''
    //     this.$refs['prestigeEvent'].field.value = vm.formCreate.fields.prestigeEvent.value
    //     this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    //     return
    //   }
    //
    //   let prestigeMTKGSubtype = ''
    //   const marketing = vm.formCreate.fields.prestigeMTKG.options.find((item) => item.value === event)
    //
    //   if (marketing) {
    //     if (marketing.congreso) {
    //       prestigeMTKGSubtype = `Congreso: ${marketing.congreso}€`
    //     } else {
    //       prestigeMTKGSubtype = `Pts app ${marketing.ptsApp ? marketing.ptsApp : ''}`
    //     }
    //   }
    //
    // 	// let prestigeSalon = this.generateSlug(vm.formCreate.fields.prestigeSalon.value, true, '_')
    // 	// const marketingList = sections.prestigeSalon[prestigeSalon].marketing
    // 	// let prestigeEvent = false
    // 	// let marketing
    // 	// let prestigeMTKGSubtype = ''
    // 	// switch (vm.formCreate.fields.prestigeMTKG.value) {
    // 	//   case 'Wella APP':
    // 	//     vm.formCreate.fields.prestigeATS.value = ''
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `Pts app ${marketing && marketing.ptsApp ? marketing.ptsApp : ''}`
    // 	//     prestigeEvent = false
    // 	//     break
    // 	//   case '€ Congreso':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeEvent = false
    // 	//     prestigeMTKGSubtype = marketing && marketing.congreso ? `Congreso € ${marketing.congreso}` : ''
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Evento Sebastian + Wella APP':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `n/a`
    // 	//     prestigeEvent = true
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Evento Sebastian + € Congreso':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = marketing && marketing.congreso ? `Congreso € ${marketing.congreso}` : ''
    // 	//     prestigeEvent = true
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Rappel MKT':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `n/a`
    // 	//     prestigeEvent = false
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Evento Sebastian + Rappel MKT':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `n/a`
    // 	//     prestigeEvent = true
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   default:
    // 	//     marketing = null
    // 	//     prestigeEvent = false
    // 	//     prestigeMTKGSubtype = ''
    // 	// }
    //
    //   vm.formCreate.fields.prestigePTS.value = marketing && marketing.ptsApp ? marketing.ptsApp : ''
    //   vm.formCreate.fields.prestigeEducation.value = marketing && ('congreso' in marketing) ? marketing.congreso : vm.formCreate.fields.prestigeEducation.value
    //   vm.formCreate.fields.prestigeMTKGSubtype.value = prestigeMTKGSubtype
    //
    //   // this.$refs['prestigeATS'].field.value = vm.formCreate.fields.prestigeATS.value
    //   this.$refs['prestigePTS'].field.value = vm.formCreate.fields.prestigePTS.value
    //   this.$refs['prestigeEducation'].field.value = vm.formCreate.fields.prestigeEducation.value
    //   this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    // },
    // validateSelectPrestigeMTKGSubtypeBrands () {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.prestigeSalon.value === '') return
    //
    //   let brands = vm.formCreate.fields.prestigeMTKGSubtypeBrands
    //   let selected = []
    //   let notSelected = []
    //
    //   _.each(brands.value, (value, key) => {
    //     if (value) selected.push(key)
    //     else notSelected.push(key)
    //   })
    //
    //   try {
    //     if (selected.length > 0 && selected.length === 2) {
    //       _.each(notSelected, (key) => {
    //         if (brands.options[key]) brands.options[key].disabled = true
    //       })
    //     } else {
    //       _.each(brands.options, (x) => {
    //         x.disabled = false
    //       })
    //     }
    //   } catch (error) {
    //     console.log('Error', error)
    //   }
    // },
    // actionSelectPrestigeBrands (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.prestigeSalon.value === '') return
    //
    //   if (vm.formCreate.fields.prestigeMTKG.value === this.$t('private.contracts.list.fields.MTKG_options.materiales_MKT')) {
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.value = {}
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.display = false
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.options = {}
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = false
    //
    //     let prestigeBrands = {}
    //
    //     _.each(vm.formCreate.fields.prestigeBrands.value, (value, key) => {
    //       if (value) {
    //         prestigeBrands[key] = {
    //           name: vm.formCreate.fields.prestigeBrands.options[key].name,
    //           value: vm.formCreate.fields.prestigeBrands.options[key].value,
    //           disabled: false
    //         }
    //       }
    //     })
    //
    //     if (_.size(prestigeBrands) > 0) {
    //       vm.formCreate.fields.prestigeMTKGSubtypeBrands.options = prestigeBrands
    //       vm.formCreate.fields.prestigeMTKGSubtypeBrands.display = true
    //       vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = true
    //     } else {
    //       let message = {
    //         message: [vm.$t('errors.custom.010').replace('{brand}', 'Prestige')],
    //         type: 'error'
    //       }
    //
    //       vm.$root.$emit('showMessage', message)
    //     }
    //   }
    // },
    actionSelectDSOSalon (event) {
      let vm = this

      let client = _.find(vm.formCreate.fields.client.options, (client) => {
        return client.value.objectId === vm.formCreate.fields.client.value
      })

      if (!client && vm.formCreate.fields.dsoSalon.value !== '') {
        let message = {
          message: [vm.$t('errors.custom.012')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)
        vm.formCreate.fields.dsoSalon.value = ''
        vm.formCreate.fields.dsoSalon.fakeValue = ''
        this.$refs['dsoSalon'].field.value = vm.formCreate.fields.dsoSalon.value
        this.$refs['dsoSalon'].field.fakeValue = vm.formCreate.fields.dsoSalon.fakeValue
        vm.resetFieldDSO()
        vm.enabledFieldDSO(false)
        return
      }

      vm.resetFieldDSO()
      vm.enabledFieldDSO(event !== '')
      vm.formCreate.fields.dsoSalonValue.value = -1
      vm.formCreate.fields.dsoMTKG.filters.required = false
      const dso = vm.tablesDiscounts.DSO.tipoClientes.find((item) => item.tipo === vm.formCreate.fields.dsoSalon.value)
      if (dso) {
        const index = 0
        const dsoPotential = 7000
        vm.formCreate.fields.dsoSalonValue.value = index
        vm.formCreate.fields.dsoSection.value = dso.tramos[index].tramo
        vm.formCreate.fields.dsoDiscount.value = dso.tramos[index].descuento
        vm.formCreate.fields.dsoRappel.value = dso.tramos[index].rappel
        vm.formCreate.fields.briogeoRappel.value = dso.tramos[index].rappelBriogeo
        vm.formCreate.fields.dsoEducation.value = dso.tramos[index].atsEducacionValorado
        vm.formCreate.fields.dsoPotential.value = dsoPotential * client.value.employeesQuantity
        vm.formCreate.fields.dsoMTKG.filters.required = true
        const dsoMTKGOpts = []
        const dsoRappelFrequencyOpts = []
        dso.rappel.forEach((rappel) => {
          dsoRappelFrequencyOpts.push({
            fakeValue: rappel,
            value: rappel
          })
        })
        dso.marketing.forEach((marketing) => {
          dsoMTKGOpts.push(Object.assign(marketing, {
            fakeValue: marketing.nombre,
            value: marketing.nombre
          }))
        })
        vm.formCreate.fields.dsoRappelFrequency.options = dsoRappelFrequencyOpts
        vm.formCreate.fields.dsoMTKG.options = dsoMTKGOpts
      }

      // - dsoSection
      this.$refs['dsoSection'].field.value = vm.formCreate.fields.dsoSection.value
      this.$refs['dsoDiscount'].field.value = vm.formCreate.fields.dsoDiscount.value
      this.$refs['dsoRappel'].field.value = vm.formCreate.fields.dsoRappel.value
      this.$refs['briogeoRappel'].field.value = vm.formCreate.fields.briogeoRappel.value
      this.$refs['dsoPTS'].field.value = vm.formCreate.fields.dsoPTS.value
      this.$refs['dsoEducation'].field.value = vm.formCreate.fields.dsoEducation.value
      this.$refs['dsoPotential'].field.value = vm.formCreate.fields.dsoPotential.value
      this.$refs['dsoMTKG'].field.value = vm.formCreate.fields.dsoMTKG.value
      this.$refs['dsoMTKG'].field.fakeValue = vm.formCreate.fields.dsoMTKG.fakeValue
      this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value
    },
    enabledFieldDSO (enabled) {
      let vm = this

      vm.formCreate.fields.dsoSalonValue.disabled = !enabled
      vm.formCreate.fields.dsoSection.disabled = !enabled
      vm.formCreate.fields.dsoDiscount.disabled = !enabled
      vm.formCreate.fields.dsoRappelMarketing.disabled = !enabled
      vm.formCreate.fields.dsoRappel.disabled = !enabled
      vm.formCreate.fields.briogeoRappel.disabled = !enabled
      vm.formCreate.fields.dsoPTS.disabled = !enabled
      vm.formCreate.fields.dsoEducation.disabled = !enabled
      vm.formCreate.fields.dsoPotential.disabled = !enabled
      vm.formCreate.fields.dsoMTKG.disabled = !enabled
      vm.formCreate.fields.dsoMTKGSubtype.disabled = !enabled
      vm.formCreate.fields.dsoRappelFrequency.disabled = !enabled
      vm.formCreate.fields.dsoBrands.options.brandSP_DIAMOND.disabled = !enabled
      vm.formCreate.fields.dsoBrands.options.brandSASSOON.disabled = !enabled
    },
    resetFieldDSO () {
      let vm = this

      vm.formCreate.fields.dsoSection.value = ''
      vm.formCreate.fields.dsoDiscount.value = ''
      vm.formCreate.fields.dsoRappelMarketing.value = ''
      vm.formCreate.fields.dsoRappel.value = ''
      vm.formCreate.fields.briogeoRappel.value = ''
      vm.formCreate.fields.dsoPTS.value = ''
      vm.formCreate.fields.dsoEducation.value = ''
      vm.formCreate.fields.dsoPotential.value = ''
      vm.formCreate.fields.dsoMTKG.value = ''
      vm.formCreate.fields.dsoMTKG.fakeValue = ''
      vm.formCreate.fields.dsoMTKGSubtype.value = ''
      vm.formCreate.fields.dsoRappelFrequency.value = ''
      vm.formCreate.fields.dsoRappelFrequency.fakeValue = ''
      vm.formCreate.fields.dsoBrands.value = {
        brandSP_DIAMOND: false,
        brandSASSOON: false
      }
      vm.formCreate.fields.hasPrestigeCondition.value = {
        FY2223: false
      }

      this.$refs['dsoMTKG'].field.value = vm.formCreate.fields.dsoMTKG.value
      this.$refs['dsoMTKG'].field.fakeValue = vm.formCreate.fields.dsoMTKG.fakeValue
      this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value
      this.$refs['dsoRappelFrequency'].field.value = vm.formCreate.fields.dsoRappelFrequency.value
      this.$refs['dsoRappelFrequency'].field.fakeValue = vm.formCreate.fields.dsoRappelFrequency.fakeValue
    },
    actionSelectDSOMTKG (event) {
      let vm = this

      if (vm.formCreate.fields.dsoSalon.value === '') {
        vm.formCreate.fields.dsoMTKGSubtype.value = ''
        this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value
        return
      }

      let dsoMTKGSubtype = ''
      const marketing = vm.formCreate.fields.dsoMTKG.options.find((item) => item.value === event)

      if (marketing) {
        if (marketing.congreso) {
          dsoMTKGSubtype = `Congreso ${marketing.congreso}€`
        } else {
          dsoMTKGSubtype = `Pts app ${marketing.ptsApp ? marketing.ptsApp : ''}`
        }
      }

      vm.formCreate.fields.dsoPTS.value = marketing && marketing.ptsApp ? marketing.ptsApp : ''
      vm.formCreate.fields.dsoEducation.value = marketing && ('congreso' in marketing) ? marketing.congreso : vm.formCreate.fields.dsoEducation.value
      vm.formCreate.fields.dsoMTKGSubtype.value = dsoMTKGSubtype
      this.$refs['dsoPTS'].field.value = vm.formCreate.fields.dsoPTS.value
      this.$refs['dsoEducation'].field.value = vm.formCreate.fields.dsoEducation.value
      this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value
    },
    validateProrated () {
      let vm = this

      vm.formCreate.fields.proratedMonth.error = false
      vm.formCreate.fields.proratedMonth.filters.required = false
      vm.formCreate.fields.proratedMonth.disabled = true

      if (vm.formCreate.fields.prorated.value === vm.formCreate.fields.prorated.options[0].value) {
        vm.formCreate.fields.proratedMonth.filters.required = true
        vm.formCreate.fields.proratedMonth.disabled = false
      }
      this.$refs['proratedMonth'].field.value = vm.formCreate.fields.proratedMonth.value
      this.$refs['proratedMonth'].field.fakeValue = vm.formCreate.fields.proratedMonth.fakeValue
    },
    onChangeOpiQuantity (value) {
      let vm = this

      let opi1 = vm.tablesDiscounts.OPI[0]
      let opi2 = vm.tablesDiscounts.OPI[1]

      vm.formCreate.fields.opiDiscount.value = ''
      vm.formCreate.fields.opiRappel.value = ''

      if (value > 0) {
        vm.formCreate.fields.opiDiscount.value = value < opi2.limite ? opi1.descuento : opi2.descuento
        vm.formCreate.fields.opiRappel.value = value < opi2.limite ? opi1.rappel : opi2.rappel
      }

      this.$refs['opiDiscount'].field.value = vm.formCreate.fields.opiDiscount.value
      this.$refs['opiRappel'].field.value = vm.formCreate.fields.opiRappel.value
    },
    onChangeIsoQuantity (value) {
      let vm = this
      vm.formCreate.fields.wellaDiscount.value = ''
      vm.formCreate.fields.wellaVolumeRappel.value = ''
      vm.formCreate.fields.rappelMKTG.value = ''
      // vm.formCreate.fields.sebManDiscount.value = ''
      // vm.formCreate.fields.sebManRappel.value = ''

      const option = vm.findOptionInList(vm.tablesDiscounts.ISO, value)
      // const option = vm.tablesDiscounts.ISO.reduce((prev, item) => {
      //  if (value >= item.limite) {
      // 	 return item
      //  }
      //  return prev
      // }, null)

      if (value > 0 && option) {
        vm.formCreate.fields.wellaDiscount.value = option.descuentoWella
        vm.formCreate.fields.wellaVolumeRappel.value = option.rappelWella
        vm.formCreate.fields.rappelMKTG.value = option.trade
        // vm.formCreate.fields.sebManDiscount.value = option.descuentoNioxin
        // vm.formCreate.fields.sebManRappel.value = option.rappelNioxin
      }

      this.$refs['wellaDiscount'].field.value = vm.formCreate.fields.wellaDiscount.value
      this.$refs['wellaVolumeRappel'].field.value = vm.formCreate.fields.wellaVolumeRappel.value
      this.$refs['rappelMKTG'].field.value = vm.formCreate.fields.rappelMKTG.value
    },
    onChangeWellaTradeManual (value) {
      let vm = this
      if (value > 0) {
        vm.formCreate.fields.rappelMKTG.value = ''
      } else {
        const option = vm.findOptionInList(vm.tablesDiscounts.ISO, vm.formCreate.fields.wellaQuantity.value)
        // const option = vm.tablesDiscounts.iso.find((item) => vm.formCreate.fields.wellaQuantity.value >= item.limite)
        if (option) vm.formCreate.fields.rappelMKTG.value = option.trade
      }

      this.$refs['rappelMKTG'].field.value = vm.formCreate.fields.rappelMKTG.value
    },
    findOptionInList (list, value) {
      return list.reduce((prev, item) => {
        if (value >= item.limite) {
          return item
        }
        return prev
      }, null)

    },
    getTotalContracts () {
      let vm = this

      vm.getTotalContractsActive = true

      let dataToSend = ''

      api
        .contracts
        .getTotalContracts(dataToSend)
        .then((response) => {
          vm.getTotalContractsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.totalContracts = response.data.totalContracts
        })
    },
    getContracts () {
      let vm = this

      vm.getContractsActive = true
      vm.contracts = []

      let dataToSend =
        '/?ascending=' + vm.filters.ascending.value +
        '&descending=' + vm.filters.descending.value +
        '&limit=' + (vm.filters.limit.value + 1) +
        '&skip=' + vm.filters.skip.value +
        '&state=' + vm.filters.state.value +
        '&exported=' + vm.filters.exported.value +
        '&contractMode=' + vm.filters.contractMode.value +
        '&since=' + vm.filters.since.value +
        '&until=' + vm.filters.until.value +
        '&seller=' + vm.filters.seller.value +
        '&delegation=' + vm.filters.delegation.value +
        '&clientCode=' + vm.filters.clientCode.value +
        '&legalName=' + vm.filters.legalName.value

      api
        .contracts
        .getContracts(dataToSend)
        .then((response) => {
          vm.getContractsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.contracts = response.data.contracts

          _.each(vm.contracts, function (x) {
            if (x.pdf) {
              var uri_org = new URI(x.pdf.url),
                pathname = uri_org.pathname()

              x.pdf.url = env.api.baseUrl + pathname
            }

            // let prestigeSalonValue = x.prestigeSalonValue ? x.prestigeSalonValue * 1 : 0
            // let premiumSalonValue = x.premiumSalonValue ? x.premiumSalonValue * 1 : 0
            // x.sumSalonValue = prestigeSalonValue

            // let premiumDiscount1 = x.premiumDiscount1 ? x.premiumDiscount1 * 1 : 0
            // let premiumVariableDiscount1 = x.premiumVariableDiscount1 ? x.premiumVariableDiscount1 * 1 : 0
            // x.premiumDiscountTotal = premiumDiscount1 + premiumVariableDiscount1

            // let prestigeDiscount1 = x.prestigeDiscount1 ? x.prestigeDiscount1 * 1 : 0
            // let prestigeVariableDiscount1 = x.prestigeVariableDiscount1 ? x.prestigeVariableDiscount1 * 1 : 0
            // x.prestigeDiscountTotal = prestigeDiscount1 + prestigeVariableDiscount1
            //  x.prestigeDiscountTotal = prestigeDiscount1
          })

          if (vm.contracts.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.contracts.length > vm.filters.limit.value) {
            vm.nextPage = true

            vm.contracts.pop()
          } else {
            vm.nextPage = false
          }
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value !== 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getContracts()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getContracts()
      }
    },
    optionSelected (data) {
      let vm = this

      if (data.action === 'edit') {
        let stateFakeValue =
          data.element.state === 0 ? this.$t('private.contracts.list.fields.state_options.green')
            : data.element.state === 1 ? this.$t('private.contracts.list.fields.state_options.red')
              : data.element.state === 2 ? this.$t('private.contracts.list.fields.state_options.yellow')
                : data.element.state === 3 ? this.$t('private.contracts.list.fields.state_options.black')
                  : data.element.state === 4 ? this.$t('private.contracts.list.fields.state_options.purple') : ''

        if (data.element.client) {
          vm.formUpdate.fields.client.value = data.element.client.id
          vm.formUpdate.fields.clientCode.value = data.element.client.clientCode
        }

        if (data.element.client && data.element.client.associatedAccounts && data.element.client.associatedAccounts.length > 0) {
          let value = {}
          let options = {}

          _.map(data.element.client.associatedAccounts, (associatedAccount) => {
            value[associatedAccount.clientCode] =
              data.element.associatedAccount1 === associatedAccount.clientCode ? true
                : data.element.associatedAccount2 === associatedAccount.clientCode ? true
                  : data.element.associatedAccount3 === associatedAccount.clientCode

            options[associatedAccount.clientCode] = {
              name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
              disabled: true
            }
          })

          vm.formUpdate.fields.associateAccounts.value = value
          vm.formUpdate.fields.associateAccounts.options = options
          vm.formUpdate.fields.associateAccounts.display = true
        }

        let mktNewsFakeValue =
          data.element.prorated === true ? this.$t('private.contracts.list.fields.mkt_news_options.yes')
            : data.element.prorated === false ? this.$t('private.contracts.list.fields.mkt_news_options.no') : ''

        let proratedFakeValue = data.element.prorated === true
          ? this.$t('private.contracts.list.fields.prorated_options.yes')
          : data.element.prorated === false
            ? this.$t('private.contracts.list.fields.prorated_options.no') : ''

        vm.formUpdate.fields.id.value = data.element.id
        vm.formUpdate.fields.state.fakeValue = stateFakeValue
        vm.formUpdate.fields.state.value = data.element.state
        // vm.formUpdate.fields.prestigeDate.value = data.element.prestigeDate ? this.parseDate(data.element.prestigeDate) : ''
        // vm.formUpdate.fields.prestigeATS.value = data.element.prestigeATS ? data.element.prestigeATS : 0
        // vm.formUpdate.fields.prestigePTS.value = data.element.prestigePTS ? data.element.prestigePTS : ''
        // vm.formUpdate.fields.prestigeMTKG.value = data.element.prestigeMTKG ? data.element.prestigeMTKG : ''
        // vm.formUpdate.fields.prestigeMTKGSubtype.value = data.element.prestigeMTKGSubtype ? data.element.prestigeMTKGSubtype : ''
        // vm.formUpdate.fields.prestigeSalon.value = data.element.prestigeSalon ? data.element.prestigeSalon : ''
        // vm.formUpdate.fields.prestigeSalonValue.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0
        // vm.formUpdate.fields.prestigeSection1.value = data.element.prestigeSection1 ? data.element.prestigeSection1 : '0'
        // vm.formUpdate.fields.prestigeRappel1.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0
        // vm.formUpdate.fields.prestigeRappelMarketing1.value = data.element.prestigeRappelMarketing1 ? data.element.prestigeRappelMarketing1 : 0
        // vm.formUpdate.fields.prestigeDiscount1.value = data.element.prestigeDiscount1 ? data.element.prestigeDiscount1 : 0
        // vm.formUpdate.fields.prestigeVariableDiscount1.value = data.element.prestigeVariableDiscount1 ? data.element.prestigeVariableDiscount1 : 0
        // vm.formUpdate.fields.prestigePotential.value = data.element.prestigePotential ? data.element.prestigePotential : 0
        // vm.formUpdate.fields.prestigeEducation.value = data.element.prestigeEducation ? data.element.prestigeEducation : 0
        // vm.formUpdate.fields.prestigeRappelFrequency.value = vm.formUpdate.fields.prestigeSalon.value && data.element.prestigeRappelFrequency ? data.element.prestigeRappelFrequency : vm.formUpdate.fields.prestigeSalon.value ? 'anual' : ''
        // vm.formUpdate.fields.premiumDate.value = data.element.premiumDate ? this.parseDate(data.element.premiumDate.iso) : ''
        // vm.formUpdate.fields.premiumMTKG.value = data.element.premiumMTKG ? data.element.premiumMTKG : ''
        // vm.formUpdate.fields.premiumMTKGSubtype.value = data.element.premiumMTKGSubtype ? data.element.premiumMTKGSubtype : ''
        // vm.formUpdate.fields.premiumSalon.value = data.element.premiumSalon ? data.element.premiumSalon : ''
        // vm.formUpdate.fields.premiumSalonValue.value = data.element.premiumRappel1 ? data.element.premiumRappel1 : 0
        // vm.formUpdate.fields.premiumATS1.value = data.element.premiumATS ? data.element.premiumATS : 0
        // vm.formUpdate.fields.premiumSection1.value = data.element.premiumSection1 ? data.element.premiumSection1 : '0'
        // vm.formUpdate.fields.premiumRappel1.value = data.element.premiumRappel1 ? data.element.premiumRappel1 : 0
        // vm.formUpdate.fields.premiumRappelMarketing1.value = data.element.premiumRappelMarketing1 ? data.element.premiumRappelMarketing1 : 0
        // vm.formUpdate.fields.premiumDiscount1.value = data.element.premiumDiscount1 ? data.element.premiumDiscount1 : 0
        // vm.formUpdate.fields.premiumVariableDiscount1.value = data.element.premiumVariableDiscount1 ? data.element.premiumVariableDiscount1 : 0
        // vm.formUpdate.fields.premiumEducation1.value = data.element.premiumEducation ? data.element.premiumEducation : 0
        // vm.formUpdate.fields.premiumPotential.value = data.element.premiumPotential ? data.element.premiumPotential : 0
        // vm.formUpdate.fields.premiumRappelFrequency.value = vm.formUpdate.fields.premiumSalon.value && data.element.premiumRappelFrequency ? data.element.premiumRappelFrequency : vm.formUpdate.fields.premiumSalon.value ? 'anual' : ''
        vm.formUpdate.fields.dsoDate.value = data.element.dsoDate ? this.parseDate(data.element.dsoDate) : ''
        vm.formUpdate.fields.dsoPTS.value = data.element.dsoPTS ? data.element.dsoPTS : ''
        vm.formUpdate.fields.dsoMTKG.value = data.element.dsoMTKG ? data.element.dsoMTKG : ''
        vm.formUpdate.fields.dsoMTKGSubtype.value = data.element.dsoMTKGSubtype ? data.element.dsoMTKGSubtype : ''
        vm.formUpdate.fields.dsoSalon.value = data.element.dsoSalon ? data.element.dsoSalon : ''
        vm.formUpdate.fields.dsoSalonValue.value = data.element.dsoRappel ? data.element.dsoRappel : 0
        vm.formUpdate.fields.dsoSection.value = data.element.dsoSection ? data.element.dsoSection : '0'
        vm.formUpdate.fields.dsoRappel.value = data.element.dsoRappel ? data.element.dsoRappel : 0
        vm.formUpdate.fields.briogeoRappel.value = data.element.briogeoRappel ? data.element.briogeoRappel : 0
        vm.formUpdate.fields.dsoRappelMarketing.value = data.element.dsoRappelMarketing ? data.element.dsoRappelMarketing : 0
        vm.formUpdate.fields.dsoDiscount.value = data.element.dsoDiscount ? data.element.dsoDiscount : 0
        vm.formUpdate.fields.dsoPotential.value = data.element.dsoPotential ? data.element.dsoPotential : 0
        vm.formUpdate.fields.dsoEducation.value = data.element.dsoEducation ? data.element.dsoEducation : 0
        vm.formUpdate.fields.dsoRappelFrequency.value = vm.formUpdate.fields.dsoSalon.value && data.element.dsoRappelFrequency ? data.element.dsoRappelFrequency : vm.formUpdate.fields.dsoSalon.value ? 'anual' : ''
        vm.formUpdate.fields.hasPrestigeCondition.value.FY2223 = !!data.element.hasPrestigeConditionFY2223
        vm.formUpdate.fields.wellaQuantity.value = data.element.wellaQuantity ? data.element.wellaQuantity : 0
        vm.formUpdate.fields.wellaDiscount.value = data.element.wellaDiscount ? data.element.wellaDiscount : 0
        vm.formUpdate.fields.wellaVolumeRappel.value = data.element.wellaVolumeRappel ? data.element.wellaVolumeRappel : 0
        // vm.formUpdate.fields.sebManRappel.value = data.element.sebManRappel ? data.element.sebManRappel : 0
        // vm.formUpdate.fields.sebManDiscount.value = data.element.sebManDiscount ? data.element.sebManDiscount : 0
        vm.formUpdate.fields.rappelMKTG.value = data.element.rappelMKTG ? data.element.rappelMKTG : 0
        vm.formUpdate.fields.rappelMKTGManual.value = data.element.rappelMKTGManual ? data.element.rappelMKTGManual : ''
        vm.formUpdate.fields.observations.value = data.element.observations ? data.element.observations : ''
        vm.formUpdate.fields.mktNews.fakeValue = mktNewsFakeValue
        vm.formUpdate.fields.mktNews.value = !!data.element.mktNews
        vm.formUpdate.fields.opiQuantity.value = data.element.opiQuantity ? data.element.opiQuantity : 0
        vm.formUpdate.fields.opiDiscount.value = data.element.opiDiscount ? data.element.opiDiscount : 0
        vm.formUpdate.fields.opiRappel.value = data.element.opiRappel ? data.element.opiRappel : 0
        vm.formUpdate.fields.prorated.value = proratedFakeValue
        vm.formUpdate.fields.proratedMonth.value = data.element.proratedMonth ? data.element.proratedMonth : ''

        if (data.element.pdf) {
          vm.formUpdate.fields.pdf.fileReady = true
          vm.formUpdate.fields.pdf.value.data = data.element.pdf
          vm.formUpdate.fields.pdf.value.format = 'pdf'
          vm.formUpdate.fields.pdf.value.size = 0
        }

        // _.map(data.element.premiumBrands, (brand) => {
        //   vm.formUpdate.fields.premiumBrands.value[brand] = true
        // })
        // _.map(data.element.prestigeBrands, (brand) => {
        //   vm.formUpdate.fields.prestigeBrands.value[brand] = true
        // })

        _.map(data.element.dsoBrands, (brand) => {
          vm.formUpdate.fields.dsoBrands.value[brand] = true
        })

        vm.displayUpdateContract = true
      } else if (data.action === 'archive') {
        vm.archiveContract(data.element)
      }
    },
    searchClients (data) {
      let vm = this

      vm.getSearchClients = true

      let dataToSend = '?clientCode=' + data

      api
        .clients
        .getClients(dataToSend)
        .then((response) => {
          vm.getSearchClients = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let clients = response.data.clients

          clients = _.map(clients, (client) => {
            return {
              fakeValue: client.legalName + ' (' + client.clientCode + ')',
              value: client
            }
          })

          vm.formCreate.fields.client.options = clients
          vm.formUpdate.fields.client.options = clients
        })
    },
    clientSelected (data) {
      let vm = this

      vm.formCreate.fields.client.value = data.id
      vm.formUpdate.fields.client.value = data.id

      if (data.associatedAccounts.length === 0) {
        return
      }

      let value = {}
      let options = {}

      _.map(data.associatedAccounts, (associatedAccount) => {
        value[associatedAccount.clientCode] = true

        options[associatedAccount.clientCode] = {
          name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
          disabled: true
        }
      })

      vm.formCreate.fields.associateAccounts.value = value
      vm.formCreate.fields.associateAccounts.options = options
      vm.formCreate.fields.associateAccounts.display = true
      vm.formUpdate.fields.associateAccounts.value = value
      vm.formUpdate.fields.associateAccounts.options = options
      vm.formUpdate.fields.associateAccounts.display = true
    },
    resetForm () {
      let vm = this

      vm.formCreate.fields.client.value = ''
      vm.formCreate.fields.state.value = ''
      vm.formCreate.fields.appCreationDate.value = ''
      vm.formCreate.fields.associateAccounts.value = {}
      vm.formCreate.fields.associateAccounts.options = []
      // vm.formCreate.fields.premiumDate.value = ''
      // vm.formCreate.fields.premiumBrands.value = ''
      // vm.formCreate.fields.premiumMTKG.value = ''
      // vm.formCreate.fields.premiumMTKG.filters.required = false
      // vm.formCreate.fields.premiumMTKGSubtype.filters.required = false
      // vm.formCreate.fields.premiumMTKGSubtype.value = ''
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.value = ''
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.display = false
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = false
      // vm.formCreate.fields.premiumSalon.value = ''
      // vm.formCreate.fields.premiumSalon.filters.required = false
      // vm.formCreate.fields.premiumSalonValue.value = -1
      // vm.formCreate.fields.premiumATS1.value = ''
      // vm.formCreate.fields.premiumPTS1.value = ''
      // vm.formCreate.fields.premiumSection1.value = ''
      // vm.formCreate.fields.premiumRappel1.value = ''
      // vm.formCreate.fields.premiumRappelMarketing1.value = ''
      // vm.formCreate.fields.premiumDiscount1.value = ''
      // vm.formCreate.fields.premiumVariableDiscount1.value = ''
      // vm.formCreate.fields.premiumEducation1.value = ''
      // vm.formCreate.fields.premiumPotential.value = ''
      // vm.formCreate.fields.premiumRappelFrequency.value = ''
      // vm.formCreate.fields.prestigeDate.value = ''
      // vm.formCreate.fields.prestigeATS.value = ''
      // vm.formCreate.fields.prestigePTS.value = ''
      // vm.formCreate.fields.prestigeMTKG.value = ''
      // vm.formCreate.fields.prestigeMTKG.filters.required = false
      // vm.formCreate.fields.prestigeBrands.value = ''
      // vm.formCreate.fields.prestigeMTKGSubtype.value = ''
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.value = ''
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.display = false
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = false
      // vm.formCreate.fields.prestigeSalon.value = ''
      // vm.formCreate.fields.prestigeSalon.filters.required = false
      // vm.formCreate.fields.prestigeSalonValue.value = -1
      // vm.formCreate.fields.prestigeSection1.value = ''
      // vm.formCreate.fields.prestigeRappel1.value = ''
      // vm.formCreate.fields.prestigeRappelMarketing1.value = ''
      // vm.formCreate.fields.prestigeDiscount1.value = ''
      // vm.formCreate.fields.prestigeVariableDiscount1.value = ''
      // vm.formCreate.fields.prestigeEducation.value = ''
      // vm.formCreate.fields.prestigePotential.value = ''
      // vm.formCreate.fields.prestigeRappelFrequency.value = ''
      vm.formCreate.fields.dsoDate.value = ''
      vm.formCreate.fields.dsoPTS.value = ''
      vm.formCreate.fields.dsoMTKG.value = ''
      vm.formCreate.fields.dsoMTKG.filters.required = false
      vm.formCreate.fields.dsoBrands.value = ''
      vm.formCreate.fields.dsoMTKGSubtype.value = ''
      vm.formCreate.fields.dsoSalon.value = ''
      vm.formCreate.fields.dsoSalon.filters.required = false
      vm.formCreate.fields.dsoSalonValue.value = -1
      vm.formCreate.fields.dsoSection.value = ''
      vm.formCreate.fields.dsoRappel.value = ''
      vm.formCreate.fields.briogeoRappel.value = ''
      vm.formCreate.fields.dsoRappelMarketing.value = ''
      vm.formCreate.fields.dsoDiscount.value = ''
      vm.formCreate.fields.dsoEducation.value = ''
      vm.formCreate.fields.dsoPotential.value = ''
      vm.formCreate.fields.dsoRappelFrequency.value = ''
      vm.formCreate.fields.hasPrestigeCondition.value.FY2223 = false
      vm.formCreate.fields.wellaQuantity.value = ''
      vm.formCreate.fields.wellaDiscount.value = ''
      vm.formCreate.fields.wellaVolumeRappel.value = ''
      // vm.formCreate.fields.sebManRappel.value = ''
      // vm.formCreate.fields.sebManDiscount.value = ''
      vm.formCreate.fields.rappelMKTG.value = ''
      vm.formCreate.fields.rappelMKTGManual.value = ''
      vm.formCreate.fields.opiQuantity.value = ''
      vm.formCreate.fields.opiDiscount.value = ''
      vm.formCreate.fields.opiRappel.value = ''
      vm.formCreate.fields.observations.value = ''
      // vm.formCreate.fields.brands.value.premium = false
      vm.formCreate.fields.brands.value.dso = false
      vm.formCreate.fields.brands.value.iso = false
      vm.formCreate.fields.brands.value.opi = false
      // vm.formCreate.fields.brands.options.premium.value = false
      // vm.formCreate.fields.brands.options.prestige.value = false
      vm.formCreate.fields.brands.options.dso.value = false
      vm.formCreate.fields.brands.options.iso.value = false
      vm.formCreate.fields.brands.options.opi.value = false
      // vm.formCreate.fields.brands.options.premium.disabled = false
      // vm.formCreate.fields.brands.options.prestige.disabled = false
      vm.formCreate.fields.brands.options.dso.disabled = false
      vm.formCreate.fields.brands.options.iso.disabled = false
      vm.formCreate.fields.brands.options.opi.disabled = false
      vm.exportZipPDFsWindow.fields.year.value = ''
      vm.exportZipPDFsWindow.fields.month.value = ''
      vm.formCreate.fields.prorated.value = ''
      vm.formCreate.fields.proratedMonth.value = ''
      vm.formCreate.fields.proratedMonth.disabled = true
      vm.formCreate.fields.proratedMonth.filters.required = false
      vm.formCreate.fields.opiQuantity.disabled = false
      vm.formCreate.fields.opiDiscount.disabled = false
      vm.formCreate.fields.opiRappel.disabled = false

      _.each(_.keys(vm.formCreate.fields), function (key) {
        vm.formCreate.fields[key].error = false
      })
    },
    formCreateSubmit () {
      let vm = this

      if (vm.formCreate.active) {
        return
      }

      vm.formCreate.active = true

      vm.$root.$emit('validate', [vm.formCreate.fields, (response) => {
        if (!response.success) {
          vm.formCreate.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        if (!_.some(vm.formCreate.fields.brands.value)) {
          vm.formCreate.active = false

          let message = {
            message: [vm.$t('errors.custom.013')],
            type: 'error'
          }

          vm.$root.$emit('showMessage', message)

          return
        }

        if (vm.formCreate.fields.brands.value.iso &&
          vm.formCreate.fields.wellaQuantity.value === '' &&
          vm.formCreate.fields.wellaDiscount.value === '' &&
          vm.formCreate.fields.wellaVolumeRappel.value === '' &&
          // vm.formCreate.fields.sebManRappel.value === '' &&
          // vm.formCreate.fields.sebManDiscount.value === '' &&
          vm.formCreate.fields.rappelMKTG.value === '' &&
          vm.formCreate.fields.rappelMKTGManual.value === ''
        ) {
          vm.formCreate.active = false

          let message = {
            message: [vm.$t('errors.custom.014')],
            type: 'error'
          }

          vm.$root.$emit('showMessage', message)

          return
        }

        if (vm.formCreate.fields.brands.value.opi &&
          vm.formCreate.fields.opiQuantity.value === '' &&
          vm.formCreate.fields.opiRappel.value === '') {
          vm.formCreate.active = false

          let message = {
            message: [vm.$t('errors.custom.014')],
            type: 'error'
          }

          vm.$root.$emit('showMessage', message)

          return
        }

        let appCreationDate = vm.formCreate.fields.appCreationDate.value ? moment(vm.formCreate.fields.appCreationDate.value).toDate() : moment().toDate()

        let dataToSend = {
          appCreationDate: appCreationDate,
          client: vm.formCreate.fields.client.value,
          state: vm.formCreate.fields.state.value,
          observations: vm.formCreate.fields.observations.value,
          pdf: vm.formCreate.fields.pdf.value,
          prorated: vm.formCreate.fields.prorated.value,
          proratedMonth: vm.formCreate.fields.proratedMonth.value
        }

        // if (vm.formCreate.fields.brands.value.premium) {
        //   dataToSend['premiumDate'] = vm.formCreate.fields.premiumSalon.value ? appCreationDate : undefined
        //   dataToSend['premiumMTKG'] = vm.formCreate.fields.premiumMTKG.value
        //   dataToSend['premiumMTKGSubtype'] = vm.formCreate.fields.premiumMTKGSubtype.value
        //   dataToSend['premiumSalon'] = vm.formCreate.fields.premiumSalon.value
        //   dataToSend['premiumSalonValue'] = vm.formCreate.fields.premiumSalonValue.value
        //   dataToSend['premiumATS'] = vm.formCreate.fields.premiumATS1.value
        //   dataToSend['premiumPTS'] = vm.formCreate.fields.premiumPTS1.value
        //   dataToSend['premiumSection1'] = vm.formCreate.fields.premiumSection1.value
        //   dataToSend['premiumRappel1'] = vm.formCreate.fields.premiumRappel1.value
        //   dataToSend['premiumRappelMarketing1'] = vm.formCreate.fields.premiumRappelMarketing1.value
        //   dataToSend['premiumDiscount1'] = vm.formCreate.fields.premiumDiscount1.value
        //   dataToSend['premiumVariableDiscount1'] = vm.formCreate.fields.premiumVariableDiscount1.value
        //   dataToSend['premiumEducation'] = vm.formCreate.fields.premiumEducation1.value
        //   dataToSend['premiumPotential'] = vm.formCreate.fields.premiumPotential.value
        //   dataToSend['premiumRappelFrequency'] = vm.formCreate.fields.premiumRappelFrequency.value
        //   dataToSend['premiumBrands'] = []
        //
        //   _.each(vm.formCreate.fields.premiumBrands.value, (value, key) => {
        //     if (value) dataToSend.premiumBrands.push(vm.formCreate.fields.premiumBrands.options[key].value)
        //   })
        //
        //   dataToSend['prestigeSalonValue'] = vm.formCreate.fields.prestigeSalon.value || -1
        // }

        // if (vm.formCreate.fields.brands.value.prestige) {
        //   dataToSend['prestigeSalon'] = vm.formCreate.fields.prestigeSalon.value
        //   dataToSend['prestigeDate'] = vm.formCreate.fields.prestigeSalon.value ? appCreationDate : undefined
        //   dataToSend['prestigeSalonValue'] = vm.formCreate.fields.prestigeSalonValue.value
        //   // dataToSend['prestigeATS'] = vm.formCreate.fields.prestigeATS.value
        //   dataToSend['prestigeBrands'] = []
        //   dataToSend['prestigeMTKG'] = vm.formCreate.fields.prestigeMTKG.value
        //   dataToSend['prestigeMTKGSubtype'] = vm.formCreate.fields.prestigeMTKGSubtype.value
        //   dataToSend['prestigePTS'] = vm.formCreate.fields.prestigePTS.value
        //   dataToSend['prestigeSection1'] = vm.formCreate.fields.prestigeSection1.value
        //   dataToSend['prestigeRappel1'] = vm.formCreate.fields.prestigeRappel1.value
        //   dataToSend['prestigeDiscount1'] = vm.formCreate.fields.prestigeDiscount1.value
        //   // dataToSend['prestigeVariableDiscount1'] = vm.formCreate.fields.prestigeVariableDiscount1.value
        //   dataToSend['prestigeRappelMarketing1'] = vm.formCreate.fields.prestigeRappelMarketing1.value
        //   dataToSend['prestigeEducation'] = vm.formCreate.fields.prestigeEducation.value
        //   dataToSend['prestigePotential'] = vm.formCreate.fields.prestigePotential.value
        //   dataToSend['prestigeRappelFrequency'] = vm.formCreate.fields.prestigeRappelFrequency.value
        //   dataToSend['hasPrestigeConditionFY2223'] = vm.formCreate.fields.hasPrestigeCondition.value.FY2223
        //
        //   _.each(vm.formCreate.fields.prestigeBrands.value, (value, key) => {
        //     if (value) dataToSend.prestigeBrands.push(vm.formCreate.fields.prestigeBrands.options[key].value)
        //   })
        //
        //   // dataToSend['premiumSalonValue'] = vm.formCreate.fields.premiumSalonValue.value || -1
        // }

        if (vm.formCreate.fields.brands.value.dso) {
          dataToSend['dsoSalon'] = vm.formCreate.fields.dsoSalon.value
          dataToSend['dsoDate'] = vm.formCreate.fields.dsoSalon.value ? appCreationDate : undefined
          dataToSend['dsoSalonValue'] = vm.formCreate.fields.dsoSalonValue.value
          dataToSend['dsoBrands'] = []
          dataToSend['dsoMTKG'] = vm.formCreate.fields.dsoMTKG.value
          dataToSend['dsoMTKGSubtype'] = vm.formCreate.fields.dsoMTKGSubtype.value
          dataToSend['dsoPTS'] = vm.formCreate.fields.dsoPTS.value
          dataToSend['dsoSection'] = vm.formCreate.fields.dsoSection.value
          dataToSend['dsoRappel'] = vm.formCreate.fields.dsoRappel.value
          dataToSend['briogeoRappel'] = vm.formCreate.fields.briogeoRappel.value
          dataToSend['dsoDiscount'] = vm.formCreate.fields.dsoDiscount.value
          dataToSend['dsoRappelMarketing'] = vm.formCreate.fields.dsoRappelMarketing.value
          dataToSend['dsoEducation'] = vm.formCreate.fields.dsoEducation.value
          dataToSend['dsoPotential'] = vm.formCreate.fields.dsoPotential.value
          dataToSend['dsoRappelFrequency'] = vm.formCreate.fields.dsoRappelFrequency.value
          dataToSend['hasPrestigeConditionFY2223'] = vm.formCreate.fields.hasPrestigeCondition.value.FY2223

          _.each(vm.formCreate.fields.dsoBrands.value, (value, key) => {
            if (value) dataToSend.dsoBrands.push(vm.formCreate.fields.dsoBrands.options[key].value)
          })
        }

        if (vm.formCreate.fields.brands.value.iso) {
          dataToSend['wellaQuantity'] = vm.formCreate.fields.wellaQuantity.value
          dataToSend['wellaDiscount'] = vm.formCreate.fields.wellaDiscount.value
          dataToSend['wellaVolumeRappel'] = vm.formCreate.fields.wellaVolumeRappel.value
          // dataToSend['sebManRappel'] = vm.formCreate.fields.sebManRappel.value
          // dataToSend['sebManDiscount'] = vm.formCreate.fields.sebManDiscount.value
          dataToSend['rappelMKTG'] = vm.formCreate.fields.rappelMKTG.value
          dataToSend['rappelMKTGManual'] = vm.formCreate.fields.rappelMKTGManual.value
        }

        if (vm.formCreate.fields.brands.value.opi) {
          dataToSend['opiQuantity'] = vm.formCreate.fields.opiQuantity.value
          dataToSend['opiDiscount'] = vm.formCreate.fields.opiDiscount.value
          dataToSend['opiRappel'] = vm.formCreate.fields.opiRappel.value
        }

        let loop = 1

        for (let i in vm.formCreate.fields.associateAccounts.value) {
          if (vm.formCreate.fields.associateAccounts.value[i]) {
            dataToSend['associatedAccount' + loop] = i

            loop++
          }
        }

        api
          .contracts
          .createContract(dataToSend)
          .then((response) => {
            vm.formCreate.active = false

            if (response.status !== 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code === 101) {
                let message = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              return
            }

            let message = {
              message: [vm.$t('private.contracts.list.create_success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getContracts()

            vm.resetForm()

            vm.getTotalContracts()

            vm.displayCreateContract = false
          })
      }])
    },
    formUpdateSubmit () {
      let vm = this

      if (vm.formUpdate.active) {
        return
      }

      vm.formUpdate.active = true

      vm.$root.$emit('validate', [vm.formUpdate.fields, (response) => {
        if (!response.success) {
          vm.formUpdate.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          id: vm.formUpdate.fields.id.value,
          client: vm.formUpdate.fields.client.value,
          state: vm.formUpdate.fields.state.value,
          wellaQuantity: vm.formUpdate.fields.wellaQuantity.value,
          wellaDiscount: vm.formUpdate.fields.wellaDiscount.value,
          wellaVolumeRappel: vm.formUpdate.fields.wellaVolumeRappel.value,
          // sebManRappel: vm.formUpdate.fields.sebManRappel.value,
          // sebManDiscount: vm.formUpdate.fields.sebManDiscount.value,
          rappelMKTG: vm.formUpdate.fields.rappelMKTG.value,
          rappelMKTGManual: vm.formUpdate.fields.rappelMKTGManual.value,
          // wellaTotalRappel: vm.formUpdate.fields.wellaTotalRappel.value,
          // wellaPotential: vm.formUpdate.fields.wellaPotential.value,
          // rappelAntecipado: vm.formUpdate.fields.rappelAntecipado.value,

          // nioxinQuantity        : vm.formUpdate.fields.nioxinQuantity.value,
          // nioxinSupport         : vm.formUpdate.fields.nioxinSupport.value,
          // spQuantity            : vm.formUpdate.fields.spQuantity.value,
          // spSupport             : vm.formUpdate.fields.spSupport.value,
          // systemECQuantity      : vm.formUpdate.fields.systemECQuantity.value,
          // systemECSupport       : vm.formUpdate.fields.systemECSupport.value,
          // sebastianQuantity     : vm.formUpdate.fields.sebastianQuantity.value,
          // sebastianSupport      : vm.formUpdate.fields.sebastianSupport.value,
          // sebastianBrandRappel  : vm.formUpdate.fields.sebastianBrandRappel.value,
          // sebastianGrowthRappel : vm.formUpdate.fields.sebastianGrowthRappel.value,
          // sebastianTotalRappel  : vm.formUpdate.fields.sebastianTotalRappel.value,
          // nioxinPotential       : vm.formUpdate.fields.nioxinPotential.value,
          // spPotential           : vm.formUpdate.fields.spPotential.value,
          // systemECPotential     : vm.formUpdate.fields.systemECPotential.value,
          // sebastianPotential    : vm.formUpdate.fields.sebastianPotential.value,
          // training              : vm.formUpdate.fields.training.value,
          observations: vm.formUpdate.fields.observations.value,
          mktNews: vm.formUpdate.fields.mktNews.value
        }

        if (_.has(vm.formUpdate.fields.pdf.value, 'data') && !vm.formUpdate.fields.pdf.value.data.url) {
          dataToSend.pdf = vm.formUpdate.fields.pdf.value
        }

        let loop = 1

        for (let i in vm.formUpdate.fields.associateAccounts.value) {
          if (vm.formUpdate.fields.associateAccounts.value[i]) {
            dataToSend['associatedAccount' + loop] = i

            loop++
          }
        }

        api
          .contracts
          .updateContract(dataToSend)
          .then((response) => {
            vm.formUpdate.active = false

            if (response.status !== 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code === 101) {
                let message = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              return
            }

            let message = {
              message: [vm.$t('private.contracts.list.update_success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getContracts()

            vm.displayUpdateContract = false
          })
      }])
    },
    archiveContract (element) {
      let vm = this

      let questionModal = {
        title: this.$t('private.contracts.list.question_modal.title'),
        question: this.$t('private.contracts.list.question_modal.question')
      }

      vm.$root.$emit('question-modal', [questionModal, (response) => {
        if (response) {
          api
            .contracts
            .archiveContract(element.id)
            .then((response) => {
              vm.formUpdate.active = false

              if (response.status !== 200) {
                let message = {
                  message: [vm.$t('errors.custom.001')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (!response.data.success) {
                if (response.data.error.code === 101) {
                  let message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }

                  vm.$root.$emit('showMessage', message)
                }

                return
              }

              let message = {
                message: [vm.$t('private.contracts.list.archive_success')],
                type: 'success'
              }

              vm.$root.$emit('showMessage', message)

              vm.getContracts()
            })
        }
      }])
    },
    exportContracts () {
      let vm = this

      if (vm.exportContractsActive) {
        let message = {
          message: [vm.$t('private.contracts.list.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      vm.exportContractsActive = true

      let dataToSend = {
        timeZone: moment.tz.guess()
      }

      api
        .contracts
        .exportContracts(dataToSend)
        .then((response) => {
          vm.exportContractsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let file = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let fileURL = URL.createObjectURL(file)

          FileSaver.saveAs(file, 'contracts.xlsx')

          vm.getContracts()
        })
    },
    getDelegations () {
      let vm = this

      vm.getDelegationsActive = true

      let dataToSend = '/?descending=createdAt'

      api
        .delegations
        .getDelegations(dataToSend)
        .then((response) => {
          vm.getDelegationsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let delegations = response.data.delegations

          delegations = _.map(delegations, (delegation) => {
            return {
              fakeValue: delegation.name,
              value: delegation.id
            }
          })

          vm.filters.delegation.options = delegations
        })
    },
    parseDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    resetDataMigrateContractsWindow () {
      let vm = this

      vm.migrateContractsWindow.contractsToCreated = []
      vm.migrateContractsWindow.contractsWithErrors = []
      vm.migrateContractsWindow.fields.csv.value = {}
      vm.migrateContractsWindow.fields.csv.fileReady = false
    },
    migrateContractsSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateContractsWindow.fields.separator.value,
        csv: vm.migrateContractsWindow.fields.csv.value.data
      }

      vm.migrateContractsWindow.migrateCSVFileActive = true

      api
        .contracts
        .migrateCSVFile(dataToSend)
        .then((response) => {
          vm.migrateContractsWindow.migrateCSVFileActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateContractsWindow.contractsToCreated = response.data.contractsToCreated
          vm.migrateContractsWindow.contractsWithErrors = response.data.contractsWithErrors

          console.log(vm.migrateContractsWindow.contractsToCreated)
        })
    },
    generateSlug (name, toUpperCase, replaceSpaceBy) {
      let _name = toUpperCase ? _.deburr(name).toUpperCase() : _.deburr(name).toLowerCase()

      return _name.replace(/\s+/g, replaceSpaceBy || '').toString()
    },
    getAgreement (contract, key) {
      let agreements = []

      if (contract[`${key}1`]) agreements.push(contract[`${key}1`])
      if (contract[`${key}2`]) agreements.push(contract[`${key}2`])
      if (contract[`${key}3`]) agreements.push(contract[`${key}3`])

      if (agreements.length > 0) {
        return agreements.join(' - ')
      }
      return contract[`${key}`]
    },
    concatValues (items_1, items_2, items_3) {
      let values = []
      if (items_1) values.push(items_1)
      if (items_2) values.push(items_2)
      if (items_3) values.push(items_3)

      return _.uniq(values).join('/')
    },
    handleSendMailDigitalSignature (element) {
      let vm = this

      if (element.isSendMailDigitalSignature) {
        return
      }

      element.isSendMailDigitalSignature = true

      api
        .contracts
        .sendMailDigitalSignature({id: element.id})
        .then((response) => {
          element.isSendMailDigitalSignature = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message
            if ('message' in response.data) {
              message = {
                message: [response.data.message],
                type: 'error'
              }
            } else {
              if ('error' in response.data) {
                if (response.data.error.code === 101) {
                  message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }
                } else {
                  message = {
                    message: [vm.$t('errors.parse.001')],
                    type: 'error'
                  }
                }
              }
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let message = {
            message: [vm.$t('private.contracts.list.send_mail_success')],
            type: 'success'
          }

          vm.$root.$emit('showMessage', message)
        }).catch(error => {
        console.log('sendMailDigitalSignature > error')
        console.log(error)
        let message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)
      })
    },
    handleSendMailAutoRenew (element) {
      let vm = this

      if (element.isSendMailAutoRenew) {
        return
      }

      element.isSendMailAutoRenew = true

      api
        .contracts
        .sendMailAutoRenew({id: element.id})
        .then((response) => {
          element.isSendMailAutoRenew = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message
            if ('message' in response.data) {
              message = {
                message: [response.data.message],
                type: 'error'
              }
            } else {
              if ('error' in response.data) {
                if (response.data.error.code === 101) {
                  message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }
                } else {
                  message = {
                    message: [vm.$t('errors.parse.001')],
                    type: 'error'
                  }
                }
              }
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let message = {
            message: [vm.$t('private.contracts.list.send_mail_success')],
            type: 'success'
          }

          vm.$root.$emit('showMessage', message)
        }).catch(error => {
        console.log('sendMailAutoRenew > error')
        console.log(error)
        let message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)
      })
    },
    handleSendMailNewPackages (element) {
      let vm = this

      if (element.isSendMailNewPackages) {
        return
      }

      element.isSendMailNewPackages = true

      api
        .contracts
        .sendMailNewPackages({id: element.id})
        .then((response) => {
          element.isSendMailNewPackages = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message
            if ('message' in response.data) {
              message = {
                message: [response.data.message],
                type: 'error'
              }
            } else {
              if ('error' in response.data) {
                if (response.data.error.code === 101) {
                  message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }
                } else {
                  message = {
                    message: [vm.$t('errors.parse.001')],
                    type: 'error'
                  }
                }
              }
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let message = {
            message: [vm.$t('private.contracts.list.send_mail_success')],
            type: 'success'
          }

          vm.$root.$emit('showMessage', message)
        }).catch(error => {
        console.log('sendMailNewPackages > error')
        console.log(error)
        let message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)
      })
    },
    exportZipPDFs () {
      let vm = this

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        let message = {
          message: [vm.$t('private.contracts.list.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let year = vm.exportZipPDFsWindow.fields.year.value
      let month = vm.exportZipPDFsWindow.fields.month.value

      let since = moment().year(year).month(month - 1).startOf('month').valueOf()
      let until = moment().year(year).month(month - 1).endOf('month').valueOf()

      vm.exportZipPDFsWindow.sessionId = Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 20)
      vm.exportZipPDFsWindow.fields.month.disabled = true
      vm.exportZipPDFsWindow.fields.year.disabled = true
      vm.exportZipPDFsWindow.downloadZipPDFsActive = true

      console.log('since', moment(since).toDate())
      console.log('until', moment(until).toDate())

      let dataToSend = {
        since,
        until,
        timeZone: moment.tz.guess(),
        sessionId: vm.exportZipPDFsWindow.sessionId
      }

      api
        .contracts
        .exportZipPDFs(dataToSend)
        .then((response) => {
          vm.exportZipPDFsWindow.downloadZipPDFsActive = false
          vm.exportZipPDFsWindow.fields.month.disabled = false
          vm.exportZipPDFsWindow.fields.year.disabled = false

          if (response.status === 202) {
            let message = {
              message: [vm.$t('errors.custom.011')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            if (response.data.error.code === 101) {
              let message = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            let message = {
              message: [vm.$t('errors.custom.011')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.exportZipPDFsWindow.downloadZipPDFsActive = true
          vm.exportZipPDFsWindow.fields.month.disabled = true
          vm.exportZipPDFsWindow.fields.year.disabled = true
        })
    },
    generateMoths () {
      let vm = this

      let lang = navigator.language || navigator.userLanguage

      moment.locale(lang)

      let year = vm.exportZipPDFsWindow.fields.year.value

      console.log(year)

      let dateNow = moment()
      let dateSelectedYear = moment().year(year)
      let monthNow = 12

      if (dateNow.year() === dateSelectedYear.year()) monthNow = dateSelectedYear.month() + 1

      vm.exportZipPDFsWindow.fields.month.options = []
      vm.exportZipPDFsWindow.fields.month.disabled = true

      for (let i = 0; i < monthNow; ++i) {
        vm.exportZipPDFsWindow.fields.month.options.push({
          fakeValue: _.capitalize(moment().month(i).format('MMMM')),
          value: i + 1
        })
      }

      vm.exportZipPDFsWindow.fields.month.value = ''
      vm.exportZipPDFsWindow.fields.month.fakeValue = ''
      vm.exportZipPDFsWindow.fields.month.disabled = false
    }
  },
  components: {
    MenuMoreOptions,
    TextField,
    TextareaField,
    SelectField,
    SearchField,
    CheckboxField,
    InputCheck,
    FileField,
    DateField,
    SortField
  },
  created () {
    let vm = this

    vm.getParseConfig()

    vm.getContracts()

    vm.getTotalContracts()

    vm.searchClients('')

    vm.getDelegations()

    for (let i = moment().year() - 2; i <= moment().year(); i++) {
      vm.exportZipPDFsWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      })
    }
  },
  mounted () {
    let vm = this

    let queryProgress = new Parse.Query('Progress')

    subscriptionProgress = queryProgress.subscribe()

    subscriptionProgress.on('open', () => {
      console.log(new Date().toString(), 'subscriptionProgress opened')
    })

    subscriptionProgress.on('create', (event) => {
      vm.exportZipPDFsWindow.progress.display = true
      vm.exportZipPDFsWindow.progress.valueMax = event.get('valueMax')
    })

    subscriptionProgress.on('update', (event) => {
      let sessionId = event.get('sessionId')

      if (vm.exportZipPDFsWindow.sessionId !== sessionId) return

      let status = event.get('status')
      let count = event.get('count')
      let valueMax = event.get('valueMax')

      vm.exportZipPDFsWindow.progress.display = true
      vm.exportZipPDFsWindow.progress.value = count
      vm.exportZipPDFsWindow.progress.valueMax = valueMax

      let porcentaje = Math.floor((count / valueMax * 100))

      if (count > 0) {
        $('#progress_id_export_zippdf').text(porcentaje + '%')
        $('#progress_id_export_zippdf').attr('aria-valuenow', porcentaje)
        $('#progress_id_export_zippdf').css('width', porcentaje + '%')
      }

      if (status === 'error') {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false
        vm.exportZipPDFsWindow.progress.display = false
        vm.exportZipPDFsWindow.fields.month.disabled = false
        vm.exportZipPDFsWindow.fields.year.disabled = false
        vm.exportZipPDFsWindow.display = false

        let message = {
          message: [vm.$t('errors.custom.001')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      if (status === 'finalized') {
        // subscriptionProgress.unsubscribe();

        let archive_id = event.get('archive_id')

        if (archive_id) {
          api
            .contracts
            .getExportZipPDFs(archive_id)
            .then((response) => {
              vm.exportZipPDFsWindow.downloadZipPDFsActive = false
              vm.exportZipPDFsWindow.fields.month.disabled = false
              vm.exportZipPDFsWindow.fields.year.disabled = false

              if (response.status !== 200) {
                vm.exportZipPDFsWindow.progress.display = false

                let message = {
                  message: [vm.$t('errors.custom.001')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              let month = vm.exportZipPDFsWindow.fields.month.value
              let year = vm.exportZipPDFsWindow.fields.year.value

              let since = moment().year(year).month(month - 1).startOf('month').valueOf()
              let until = moment().year(year).month(month - 1).endOf('month').valueOf()

              let file = new Blob([response.data], {type: 'octet/stream'})
              let fileURL = URL.createObjectURL(file)

              FileSaver.saveAs(file, 'pdfs_' + since + '_' + until + '.zip')

              setTimeout(function () {
                vm.exportZipPDFsWindow.downloadZipPDFsActive = false
                vm.exportZipPDFsWindow.progress.display = false
                vm.exportZipPDFsWindow.fields.month.disabled = false
                vm.exportZipPDFsWindow.fields.year.disabled = false
                vm.exportZipPDFsWindow.display = false
              }, 3000)
            })
        }
      }
    })

    subscriptionProgress.on('error', (error) => {
      console.log('on Error')
      console.log(error)
      vm.exportZipPDFsWindow.downloadZipPDFsActive = false
      vm.exportZipPDFsWindow.fields.month.disabled = false
      vm.exportZipPDFsWindow.fields.year.disabled = false
      vm.exportZipPDFsWindow.progress.display = false
      vm.exportZipPDFsWindow.display = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/private/contracts/list/script.js